if(document.querySelector('.video-show')) {
  const modal = document.querySelector('.video-modal'), video = document.getElementById('modal-video');

  // the modal needs to be a direct child of the body otherwise the z-index is messed up
  modal.parentElement.removeChild(modal);
  document.body.appendChild(modal);

  document.querySelector('.video-show').addEventListener('click', () => {
    modal.style.display = 'block';
    video.play();
  });
  document.querySelector('.video-close').addEventListener('click', () => {
    modal.style.display = 'none';
    video.pause();
  });
}
